module.exports = "<app-visit-report \n[isOrderDone]=\"isOrderDone\" \n[requestType]=\"requestType\" \n[title]=\"title\">\n</app-visit-report>"